
import { DataProvider } from "../helpers"

import { Enums } from "../models/common"
import { OpLocationType } from "../models/core"


export class DataProviderGroupingLocationType {

    // Ctor

    constructor(private dataProvider: DataProvider) { }

    // Ctor End


    // Public Methods

    public getGroupingLocationTypesFilter = () => {
        return this.dataProvider.sendFilterRequestWithSession<OpLocationType>([], 0, 0, '', Enums.ReferenceType.IdLocationType, 'OpxGroupingLocationTypeFilter', 'OpxGroupingLocationTypeFilterResult')
    }

    public saveGroupingLocationType = (locationType: OpLocationType): JQueryPromise<OpLocationType> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveGroupingLocationType', { toSave: locationType.toJSON() }, 'OpxSaveGroupingLocationTypeResult')
            .then((response: any) => new OpLocationType(response))
    }

    // Public Methods End
}

